<template>
  <div class="ti d-flex">
    <div class="d-flex-left">
      <erp-tree-status @node-click="nodeClick"></erp-tree-status>
    </div>
    <div class="d-flex-right">
      <Row class="loading" :style="loading == true ? '' : 'display:none'">
        <Col class="demo-spin-col" span="8">
          <Spin fix>
            <Icon
              type="ios-loading"
              size="18"
              class="demo-spin-icon-load"
            ></Icon>
            <div>加载中</div>
          </Spin>
        </Col>
      </Row>
      <div>
        <el-button
          size="mini"
          type="primary text2"
          @click="modals"
          v-if="ERP.isPermission(3001001002)"
          >添加业户</el-button
        >
        <el-select
          size="mini"
          v-model="pid"
          filterable
          placeholder="请选择组织"
          class="kuan"
          v-if="ERP.isPermission(3001001001)"
        >
          <el-option key="" label="全部" value=""> </el-option>
          <el-option
            v-for="item in options"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <house-search class="search" :search.sync="text" :project_id="pindex_id" />
        <!-- <el-input size="mini" class="search" placeholder="请输入搜索业户姓名或房产" v-model="text" clearable></el-input> -->
        <el-button size="mini" type="primary text2" @click="searchs"
          >搜索</el-button
        >
      </div>
      <v-divider></v-divider>
      <v-simple-table :height="__TABLE_HEIGHT__">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">ID</th>
              <th class="text-left">业户姓名</th>
              <th class="text-left">手机号</th>
              <th class="text-left">房产</th>
              <th class="text-left">产权</th>
              <th class="text-left">日期</th>
              <th class="text-left">操作</th>
            </tr>
          </thead>
          <tbody>
            <tr class="text1" v-for="item in data" :key="item.id">
              <td>{{ item.id }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.phone }}</td>
              <td>{{ item.h_user_date }}</td>
              <td>{{ item.ownership_type_name }}</td>
              <td>{{ item.date }}</td>
              <td class="cdj_td">
                <div
                  style="color: #1867c0; cursor: pointer"
                  @click="xiugai(item)"
                  v-if="ERP.isPermission(3001001003)"
                >
                  修改
                </div>
                <div
                  style="color: red; margin-left: 5px; cursor: pointer"
                  @click="del(item.id)"
                  v-if="ERP.isPermission(3001001004)"
                >
                  删除
                </div>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <v-divider></v-divider>
      <div class="pages" v-if="data">
        <Page
          :total="count"
          :page-size="pageSize"
          @on-change="change"
          show-total
        />
      </div>
      <div class="zhanwu" v-else>没有数据</div>
      <Modal
        v-model="modal1"
        :ok-text="anxiu"
        width="600"
        title="编辑"
        :loading="loadingModal"
        @on-ok="ok"
      >
        <div>
          <el-form style="height: 600px; overflow: auto">
            <div>
              <div>
                <span><span class="cdj_span">*</span>项目</span>
                <div class="cdj_input">
                  <el-select
                    v-model="dades.pindex_id"
                    filterable
                    placeholder="请选择"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in options"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
              <div class="cdj_margin_span">
                <span><span class="cdj_span">*</span>房产</span>
                <div class="cdj_input">
                  <el-select
                    v-model="dades.house_id"
                    filterable
                    placeholder="请选择"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in optionsHouse"
                      :key="item.id"
                      :label="item.address"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
              <div class="cdj_margin_span">
                <span><span class="cdj_span">*</span>业户姓名</span>
                <el-input
                  class="cdj_input"
                  placeholder="请输入内容"
                  v-model="dades.name"
                ></el-input>
              </div>
              <div class="cdj_margin_span">
                <span><span class="cdj_span">*</span>身份证</span>
                <el-input
                  class="cdj_input"
                  placeholder="请输入内容"
                  v-model="dades.identification_card"
                ></el-input>
              </div>
              <div class="cdj_margin_span">
                <span><span class="cdj_span">*</span>电话</span>
                <el-input
                  class="cdj_input"
                  placeholder="请输入内容"
                  v-model="dades.phone"
                ></el-input>
              </div>
              <div class="cdj_margin_span">
                <span><span class="cdj_span">*</span>性别</span>
                <el-input
                  class="cdj_input"
                  placeholder="请输入内容"
                  v-model="dades.gender"
                ></el-input>
              </div>
              <div class="cdj_margin_span">
                <span>生日</span>
                <div class="cdj_input">
                  <el-date-picker
                    style="width: 100%"
                    v-model="dades.birthday"
                    type="date"
                    placeholder="选择日期"
                  ></el-date-picker>
                </div>
              </div>
              <div class="cdj_margin_span">
                <span><span class="cdj_span">*</span>产权性质</span>
                <div
                  class="cdj_input"
                  style="
                    margin-top: 10px;
                    margin-bottom: 10px;
                    margin-left: 5px;
                  "
                >
                  <el-radio v-model="dades.ownership_type" label="1"
                    >产权</el-radio
                  >
                  <el-radio v-model="dades.ownership_type" label="2"
                    >家庭成员</el-radio
                  >
                  <el-radio v-model="dades.ownership_type" label="3"
                    >租户</el-radio
                  >
                  <el-radio v-model="dades.ownership_type" label="4"
                    >老业主</el-radio
                  >
                </div>
              </div>
              <div class="cdj_margin_span">
                <span>业户分类（几星）</span>
                <el-select
                  class="cdj_input"
                  v-model="dades.customer_class"
                  filterable
                  placeholder="请选择"
                  style="width: 100%"
                >
                  <el-option
                    key="1"
                    label="特别重要客户★★★★★"
                    value="1"
                  ></el-option>
                  <el-option key="2" label="重要客户★★★★" value="2"></el-option>
                  <el-option key="3" label="普通客户★★★" value="3"></el-option>
                  <el-option key="4" label="问题客户★★" value="4"></el-option>
                  <el-option key="5" label="劣质客户★" value="5"></el-option>
                </el-select>
              </div>
              <div class="cdj_margin_span">
                <span>业户类型</span>
                <el-select
                  class="cdj_input"
                  v-model="dades.customer_type"
                  filterable
                  placeholder="请选择"
                  style="width: 100%"
                >
                  <el-option key="1" label="特别重要客户" value="1"></el-option>
                  <el-option key="2" label="重要客户" value="2"></el-option>
                  <el-option key="3" label="普通客户" value="3"></el-option>
                  <el-option key="4" label="问题客户" value="4"></el-option>
                  <el-option key="5" label="劣质客户" value="5"></el-option>
                </el-select>
              </div>
              <div class="cdj_margin_span">
                <span>特殊身份</span>
                <el-select
                  class="cdj_input"
                  v-model="dades.specialIdentity"
                  filterable
                  placeholder="请选择"
                  style="width: 100%"
                >
                  <el-option
                    key="1"
                    label="地市级政府官员"
                    value="1"
                  ></el-option>
                  <el-option
                    key="2"
                    label="物业管理行业主管领导"
                    value="2"
                  ></el-option>
                  <el-option
                    key="3"
                    label="大型公司/地产公司董事长"
                    value="3"
                  ></el-option>
                  <el-option
                    key="4"
                    label="大型公司/地产公司总裁"
                    value="4"
                  ></el-option>
                  <el-option
                    key="5"
                    label="大型公司/地产公司总经理"
                    value="5"
                  ></el-option>
                  <el-option key="6" label="知名媒体人士" value="6"></el-option>
                  <el-option key="7" label="影视明星" value="7"></el-option>
                  <el-option
                    key="8"
                    label="业委会主任/副主任"
                    value="8"
                  ></el-option>
                  <el-option key="9" label="社区主任" value="9"></el-option>
                  <el-option
                    key="10"
                    label="物业管理行业领导"
                    value="10"
                  ></el-option>
                  <el-option key="11" label="派出所领导" value="11"></el-option>
                  <el-option
                    key="12"
                    label="一般公司董事长"
                    value="12"
                  ></el-option>
                  <el-option
                    key="13"
                    label="一般公司总裁"
                    value="13"
                  ></el-option>
                  <el-option
                    key="14"
                    label="一般公司总经理"
                    value="14"
                  ></el-option>
                  <el-option
                    key="15"
                    label="地产公司物业对接人"
                    value="15"
                  ></el-option>
                  <el-option key="16" label="业委会成员" value="16"></el-option>
                  <el-option key="17" label="热心业户" value="17"></el-option>
                </el-select>
              </div>
            </div>
          </el-form>
        </div>
      </Modal>
    </div>
  </div>
</template>

<script>
import ErpTree from "../Common/erp-tree";
import HouseSearch from "@/components/common/houseSearch";
import ErpTreeStatus from "../Common/erp-tree-status";
export default {
  name: "UserOwner",
  components: {ErpTreeStatus, ErpTree, HouseSearch },
  data() {
    return {
      modal1: false,
      loading: false,
      loadingModal: true,
      optionsHouse: [],
      dades: {
        id: "",
        pindex_id: "",
        house_id: "",
        name: "",
        identification_card: "",
        phone: "",
        gender: "",
        birthday: "",
        ownership_type: "",
        customer_class: "",
        customer_type: "",
        specialIdentity: "",
      },
      options: [],
      pid: "",
      data: "",
      count: 0,
      pageSize: 12,
      text: "",
      anxiu: "保存",
      homeName: "",
      pindex_id: "",
    };
  },
  //界面没出来前加载
  created() {},
  // 加载数据
  mounted() {
    this.change(1);
    //项目列表
    this.$myhttp
      .get("admin/common/pindex", {
        "Content-Type": "application/json",
      })
      .then((backdata) => {
        this.options = backdata.data.data;
      });
  },
  //事件
  methods: {
    //保存
    ok() {
      if (this.dades.pindex_id == "") {
        this.$Message.error("项目不能为空!");
        this.loadingModals();
        return false;
      }
      if (this.dades.house_id == "") {
        this.$Message.error("房产不能为空!");
        this.loadingModals();
        return false;
      }
      if (this.dades.name == "") {
        this.$Message.error("业户姓名不能为空!");
        this.loadingModals();
        return false;
      }
      if (this.dades.identification_card == "") {
        this.$Message.error("身份证不能为空!");
        this.loadingModals();
        return false;
      }
      if (this.dades.phone == "") {
        this.$Message.error("手机号不能为空!");
        this.loadingModals();
        return false;
      }
      if (this.dades.gender == "") {
        this.$Message.error("性别不能为空!");
        this.loadingModals();
        return false;
      }
      if (this.dades.ownership_type == "") {
        this.$Message.error("产权性质不能为空!");
        this.loadingModals();
        return false;
      }
      if (this.dades.birthday != null) {
        var d = this.dades.birthday;
        this.dades.birthday = new Date(d).getTime() / 1000;
      }
      this.loading = true;
      this.$myhttp
        .post("admin/UserOwner/userOwnerAdd", this.dades, {
          "Content-Type": "application/x-www-form-urlencoded",
        })
        .then((backdata) => {
          // 异步执行成功后
          if (backdata.data[0] == 1) {
            this.change(1);
            this.dades = {
              id: "",
              pindex_id: "",
              house_id: "",
              name: "",
              identification_card: "",
              phone: "",
              gender: "",
              birthday: "",
              ownership_type: "",
              customer_class: "",
              customer_type: "",
              specialIdentity: "",
            };
            this.$Message.success(backdata.data[1]);
          } else {
            this.$Message.error("编辑失败!");
          }
          this.modal1 = false;
          this.loading = false;
        });
    },
    //弹窗添加
    modals() {
      this.anxiu = "保存";
      if (this.dades.id) {
        this.dades = {
          id: "",
          pindex_id: "",
          house_id: "",
          name: "",
          identification_card: "",
          phone: "",
          gender: "",
          birthday: "",
          ownership_type: "",
          customer_class: "",
          customer_type: "",
          specialIdentity: "",
        };
      }
      this.modal1 = true;
    },
    //获得当前多少页,分页
    change(page) {
      this.loading = true;
      this.$myhttp
        .get(
          "admin/UserOwner/index?page=" +
            page +
            "&pid=" +
            this.pid +
            "&text=" +
            this.text +
            "&homeName=" +
            this.homeName +
            "&pindex_id=" +
            this.pindex_id,
          {
            "Content-Type": "application/json",
          }
        )
        .then((backdata) => {
          // 异步执行成功后
          if (backdata.data.code == 200) {
            let data = backdata.data.data;
            this.data = data.data;
            this.count = data.count;
            this.pageSize = data.pageSize;
          }
          this.loading = false;
        });
    },
    //搜索
    searchs() {
      this.change(1);
    },
    //修改
    xiugai(item) {
      (this.dades = {
        id: item.id,
        pindex_id: item.pindex_id,
        house_id: item.house_id,
        name: item.name,
        identification_card: item.identification_card,
        phone: item.phone,
        gender: item.gender,
        birthday: item.birthday,
        ownership_type: item.ownership_type,
        customer_class: item.customer_class,
        customer_type: item.customer_type,
        specialIdentity: item.specialIdentity,
      }),
        (this.modal1 = true);
    },
    //删除
    del(e) {
      this.$confirm("此操作将永久删除该权限吗, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$Loading.start();
          this.$myhttp
            .post(
              "admin/UserOwner/userOwnerDelete",
              { id: e },
              {
                "Content-Type": "application/x-www-form-urlencoded",
              }
            )
            .then((backdata) => {
              // 异步执行成功后
              if (backdata.data == 200) {
                this.dela = true;
                this.change(1);
                this.$Message.success("删除成功!");
                this.$Loading.finish();
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //弹窗不要关闭
    loadingModals() {
      let _this = this;
      _this.loadingModal = false;
      setTimeout(() => {
        _this.loadingModal = true;
      }, 10);
    },
    nodeClick(data) {
      let tree_str = data.tree
        .map((ret) => {
          return ret.name;
        })
        .join("->");
      //console.log(data);
      this.pindex_id = data.tree[0].pindex_id;
      this.homeName = tree_str;
      this.change(1);
    },
  },
  watch: {
    //监听项目id改变
    "dades.pindex_id"(e) {
      if (this.dades.pindex_id != undefined && this.dades.pindex_id != "") {
        this.loading = true;
        this.$myhttp
          .get("admin/common/house?id=" + e, {
            "Content-Type": "application/json",
          })
          .then((backdata) => {
            this.optionsHouse = backdata.data.data;
            this.loading = false;
          });
      }
    },
  },
  computed: {
    __TABLE_HEIGHT__() {
      return ERP.getStore().__TABLE_HEIGHT__;
    },
  },
};
</script>
<style scoped>
.ti {
  margin: 1%;
  width: 98%;
}
.text1 {
  text-align: center;
}
.pages {
  margin-top: 2%;
  margin-right: 3%;
  text-align: right;
}
.search {
  margin-top: 0.2%;
  width: 20%;
  margin-bottom: 1.5%;
}
.text2 {
  color: rgb(250, 248, 248);
}
.kuan {
  width: 10%;
}
.zhanwu {
  text-align: center;
  color: rgb(207, 205, 205);
  font-size: 20px;
  margin-top: 3%;
}
.d-flex {
  display: flex;
}

.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
}

.d-flex-right {
  flex: 1;
}

.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.demo-spin-col {
  height: 100px;
  position: relative;
}
.loading {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 90%;
  position: fixed;
  width: 85%;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/User/Owner.vue